<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>
              <router-link
                class="btn btn-sm"
                :to="{ name: 'TunnelConfigurationList' }"
              >
                <i class="fas fa-chevron-left"></i>
              </router-link>
              Tunnel Configurations
            </h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'Home' }">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Tunnel Configurations</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="overlay" v-if="is_loading">
                <img src="/assets/images/loader.svg" alt="" />
              </div>
              <div class="card-header py-3">
                <h3 class="card-title">Detail</h3>
              </div>
              <div class="card-body">
                <div class="custom-list">
                  <ul>
                    <li><strong>ID</strong> {{ value.id }}</li>

                    <li><strong>Name</strong> {{ value.tunnel_name }}</li>

                    <li><strong>Type</strong> {{ value.interface_type }}</li>

                    <li><strong>Name</strong> {{ value.gre_name }}</li>

                    <li>
                      <strong>Description</strong> {{ value.gre_description }}
                    </li>

                    <li>
                      <strong>Remote GRE IP</strong>
                      {{ value.gre_remote_gre_ip }}
                    </li>

                    <li><strong>Local</strong> {{ value.gre_local_ip }}</li>

                    <li><strong>Remote</strong> {{ value.gre_remote_ip }}</li>

                    <li><strong>GRE IP</strong> {{ value.gre_ip }}</li>

                    <li><strong>RX</strong> {{ value.gre_rx }}</li>

                    <li><strong>TX</strong> {{ value.gre_tx }}</li>

                    <li><strong>Admins</strong> {{ value.is_active }}</li>

                    <li><strong>P2P</strong> {{ value.is_active_p2p }}</li>

                    <li><strong>OSPF Cost</strong> {{ value.ospf_cost }}</li>

                    <li>
                      <strong>IPSEC Encryption</strong>
                      {{ value.ipsec_encryption }}
                    </li>

                    <li>
                      <strong>Profile Name</strong>
                      {{ value.ipsec_profile_name }}
                    </li>

                    <li>
                      <strong>Remote Gateway</strong>
                      {{ value.ipsec_remote_gateway }}
                    </li>

                    <li>
                      <strong>IP Address</strong> {{ value.ipsec_ip_addr }}
                    </li>

                    <li><strong>PSK</strong> {{ value.psk }}</li>

                    <li>
                      <strong>Algorithm</strong> {{ value.ike_algorithm }}
                    </li>

                    <li><strong>Length</strong> {{ value.ike_length }}</li>

                    <li><strong>Hash</strong> {{ value.ike_hash }}</li>

                    <li><strong>DH Group</strong> {{ value.ike_dhGroup }}</li>

                    <li>
                      <strong>Algorithm</strong> {{ value.esp_algorithm }}
                    </li>

                    <li><strong>Length</strong> {{ value.esp_length }}</li>

                    <li><strong>Hash</strong> {{ value.esp_hash }}</li>

                    <li><strong>DH Group</strong> {{ value.esp_dhGroup }}</li>

                    <li>
                      <strong>IPSEC Active</strong> {{ value.ipsec_is_active }}
                    </li>

                    <li>
                      <strong>Local IP Address</strong>
                      {{ value.ipsec_local_ip }}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// import MasterLayout from "@/components/layouts/MasterLayoutComponent.vue";
import axios from 'axios'
import { Notification } from 'element-ui'
const fileDownload = require('js-file-download')

export default {
  name: 'TunnelConfigurationShow',
  metaInfo: {
    title: 'TunnelConfigurations | Dotlines'
  },
  data: () => ({
    value: {},
    pre: {},
    is_loading: false
  }),
  mounted: function () {
    this.initialize()
  },
  methods: {
    async initialize () {
      this.is_loading = true
      this.params = this.$route.params

      await this.getDetail(this.params.id).then(response => {
        this.value = response.data
      })

      this.is_loading = false
    },
    downloadFile: function (url) {
      this.is_loading = true
      axios
        .get(this.API_ASSET_UPLOAD_URL + url, { responseType: 'arraybuffer' })
        .then(response => {
          fileDownload(response.data, url.replaceAll('/', '-'))
          Notification.success({
            title: 'Download Completed',
            message: 'Download completed successfully',
            type: 'success'
          })
        })
        .catch(error => {
          Notification.error({
            title: 'Download Failed',
            message: 'Failed to download',
            type: 'error'
          })
        })
        .finally(() => {
          this.is_loading = false
        })
    },
    getDetail: function (id) {
      return new Promise((resolve, reject) => {
        const api_url = '/tunnelconfigurations/' + id
        axios
          .get(api_url)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            console.log('error ' + error)
            reject(error)
          })
          .finally(() => {})
      })
    }
  }
  /* created() {
    this.$emit("update:layout", MasterLayout);
  }, */
}
</script>
